module.exports = __webpack_public_path__ + "img/L4.448c9fca.png";